module.exports = __webpack_public_path__ + "static/media/bothive-logo.cb573827.svg";